module.exports = __webpack_public_path__ + "img/hr-fast-splitter-east.b415b897.png";